import { createSelector } from 'reselect';
import { IAppState } from 'types/app';
import { IArea } from 'types/map';
import asStateAwareArea from 'mapping/asStateAwareArea';

const getAreas: (state: IAppState) => IArea[] = (state: IAppState) => state.map.areas || [];
const getCurrentArea: (state: IAppState) => IArea | undefined = (state) => state.map.currentArea;

function outputFunc(areas: IArea[], currentArea: IArea | undefined) {
  return areas.map(a => asStateAwareArea(a, areas, currentArea));
}

export default createSelector(
  [getAreas, getCurrentArea],
  outputFunc,
);